import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Sparkles } from 'lucide-react';
import DocIntelTemplateDrafts from '../components/docIntelligence/DocIntelTemplateDrafts';
import DocIntelTemplatePanel from '../components/docIntelligence/DocIntelTemplatePanel';
import DocIntelWorkspace from '../components/docIntelligence/DocIntelWorkspace';

const DocIntelTemplateStudio = () => {
  const { id: projectId } = useParams();
  const navigate = useNavigate();
  const numericProjectId = Number(projectId);
  const [editingTemplateId, setEditingTemplateId] = useState(null);
  /** When set, workspace opens this review session (from template → Review fields). */
  const [openReviewSessionId, setOpenReviewSessionId] = useState(null);

  const goToPropertyTemplates = () => {
    if (!projectId) {
      navigate(-1);
      return;
    }
    navigate(`/builder/management/company/projects/${projectId}`, {
      replace: true,
      state: { secondaryTab: 'Property Templates' }
    });
  };

  const handlePromoted = () => {
    setEditingTemplateId(null);
    setOpenReviewSessionId(null);
    goToPropertyTemplates();
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="border-b border-slate-200 bg-white px-4 py-3 sm:px-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-start gap-3">
            <button
              type="button"
              onClick={goToPropertyTemplates}
              className="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50">
              <ArrowLeft className="h-4 w-4" />
            </button>
            <div>
              <h1 className="flex items-center gap-2 text-lg font-semibold text-slate-900">
                <Sparkles className="h-5 w-5 text-teal-700" />
                AI Template Studio
              </h1>
              <p className="mt-0.5 text-sm text-slate-500">
                Upload a sample agreement, map fields once, then promote — templates only (no
                per-deal PDFs here).
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-3 py-4 sm:px-5 lg:px-6">
        <DocIntelTemplateDrafts
          projectId={numericProjectId}
          selectedId={editingTemplateId}
          onSelect={(id) => {
            setOpenReviewSessionId(null);
            setEditingTemplateId(id);
          }}
          onDeleted={(id) => {
            if (editingTemplateId === id) setEditingTemplateId(null);
          }}
        />

        {editingTemplateId ? (
          <DocIntelTemplatePanel
            key={editingTemplateId}
            projectId={numericProjectId}
            templateId={editingTemplateId}
            studioMode
            onBack={() => setEditingTemplateId(null)}
            onPromoted={handlePromoted}
            onOpenReview={(sessionId) => {
              if (!sessionId) return;
              setEditingTemplateId(null);
              setOpenReviewSessionId(sessionId);
            }}
          />
        ) : (
          <DocIntelWorkspace
            mode="template"
            projectId={numericProjectId}
            onPromoted={handlePromoted}
            openReviewSessionId={openReviewSessionId}
            onOpenReviewSessionConsumed={() => setOpenReviewSessionId(null)}
          />
        )}
      </div>
    </div>
  );
};

export default DocIntelTemplateStudio;
